import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { DatePipe, JsonPipe } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { appRoutes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { AppconfigService } from '@core/services/utility/appconfig.service';
import { assessmentDetailsReducer } from '@core/store/assessment-details/assessment-details.reducer';
import { globalizationSettingsReducer } from '@core/store/globalization-settings/globalization-settings.reducer';
import { permissionsFeature } from '@core/store/permissions/permissions.reducer';
import { registerReducer } from '@core/store/register/register.reducer';
import { environment } from '@environments/environment';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { provideStore, provideState } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoginService } from '@core/auth/services/login.service';
import { httpRequestInterceptor } from '@core/interceptors/http.interceptor';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { PermissionPipe } from './shared/pipes/permission.pipe';
import { appConfigFeature } from '@core/store/application-configuration/application-configuration.reducer';
import { DateOffsetPipe } from './shared/pipes/date-offset.pipe';

export function tokenGetter() {
  return localStorage.getItem('access_token');
}

export async function initializeApp(appConfigService: AppconfigService): Promise<void> {
    await appConfigService.LoadConfig();
}

export function AppModuleHttpLoaderFactory(
    http: HttpClient,
): TranslateHttpLoader {
    return new TranslateHttpLoader(
        http,
        environment.baseUrl +
            `/api/${environment.defaultApiVersion}/Localization/GetAllResourcesByLocalizationModules?LocalizationModules=APPLICATION_COMMON,RISK_ACTION,`,
        '',
    );
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => initializeApp(
      inject(AppconfigService),
    )),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([httpRequestInterceptor, authInterceptor])),
    provideAnimations(),
    provideTranslateService({
          loader: {
            provide: TranslateLoader,
            useFactory: AppModuleHttpLoaderFactory,
            deps: [HttpClient],
          },
          defaultLanguage: ' ',
          extend: true
    }),
    importProvidersFrom(
      JwtModule.forRoot({
        config: { tokenGetter },
      }),
      ReactiveFormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }),
      NgIdleKeepaliveModule.forRoot(),
    ),
    provideStore({
      assessmentDetailId: assessmentDetailsReducer,
      globalizationSettings: globalizationSettingsReducer,
      registerId: registerReducer,
    }),
    provideState(permissionsFeature),
    provideState(appConfigFeature),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
    }),
    LoginService,
    DatePipe,
    PermissionPipe,
    JsonPipe,
    DateOffsetPipe
  ],
}